import { Flex } from '@chakra-ui/layout';
import {
  Box,
  Heading,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
} from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router';

import { useCreditFacilitiesOrThrow } from '~/contexts/CreditFacilitiesProvider';
import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';
import {
  PermissionGuard,
  PermissionsFn,
  usePermissionGuard,
} from '~/core/PermissionGuard';
import { CommonFacilitySelect } from '~/packages/credit-facility/ui/CreditFacilitySelect';
import { ServicerReportsTable } from '~/packages/reporting/ui/ServicerReportsTable';
import { ReportsTable } from '~/packages/reports/ui/ReportsTable';

// Fragments
const RouteBase = () => {
  const { facilities } = useCreditFacilitiesOrThrow();
  const [creditFacilityId, setCreditFacilityId] = useState<string>();
  useEffect(() => {
    if (facilities[0]?.id) setCreditFacilityId(facilities[0].id);
  }, [facilities]);

  const isReportsTabVisible =
    usePermissionGuard(
      (context) => context.flags.productsReportsReportsTabPermissions,
    ) === 'allow';

  return (
    <>
      <Flex justify="space-between">
        <Heading>Reports</Heading>
        <Box>
          <CommonFacilitySelect
            isSearchable
            selectedFacilityId={creditFacilityId}
            onFacilitySelect={setCreditFacilityId}
          />
        </Box>
      </Flex>
      {creditFacilityId && (
        <Tabs variant="line" colorScheme="black">
          <TabList>
            {isReportsTabVisible && <Tab>Reports</Tab>}

            <Tab>Servicer Reports</Tab>
          </TabList>

          <TabPanels>
            {isReportsTabVisible && (
              <TabPanel>
                <ReportsTable creditFacilityId={creditFacilityId} />
              </TabPanel>
            )}

            <TabPanel>
              <ServicerReportsTable creditFacilityId={creditFacilityId} />
            </TabPanel>
          </TabPanels>
        </Tabs>
      )}
    </>
  );
};

// Exports
export const permissions: PermissionsFn = (context) => {
  if (context.user.organization.slug === 'valleyBank') return 'deny';
  return context.flags.productsReportsPermissions;
};
export const Route = () => (
  <PermissionGuard
    permissions={permissions}
    fallback={<Navigate to="/" replace />}
  >
    <RouteErrorBoundary
      fallback={({ message, showErrorToast }) => {
        showErrorToast(message);
        return <Navigate to="/" />;
      }}
    >
      <Flex
        direction="column"
        padding={['1.5rem', '1.5rem', '1.5rem', '2.5rem']}
        id="reports-route-container"
      >
        <RouteBase />
      </Flex>
    </RouteErrorBoundary>
  </PermissionGuard>
);
